// extracted by mini-css-extract-plugin
export default {"input":"search_input__Dso9Z","dropdown":"search_dropdown__pYTRi","btn":"search_btn__mysuk"};